// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../Components/footer.css";
import logo from "../img/ast_ylw_logo.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Left Section - Paragraph */}
          <div className="col-md-4">
            <div className="footer-about">
              <img src={logo} alt="Company Logo" className="img-fluid" />
              <p>
                <b>Where Tournaments Come to Life..!!</b>
              </p>
            </div>
          </div>

          {/* Middle Section - Vertical Navigation Links */}
          <div className="col-md-4">
            <nav className="footer-nav">
              <h5>Quick Links</h5>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/events">Gallery</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/tournament">Tournaments</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                </ul>

            </nav>
          </div>

          {/* Right Section - Contact Details & Social Media */}
          <div className="col-md-4">
            <div className="footer-contact">
              <h5>Contact Us</h5>
              <p><strong>Address:</strong> Kamalam Elite, Office 406/407 , 4th Floor. Opposite BNB Polytechnic College. Near Iskcon Temple. Vallabh Vidya Nagar. Anand -388120 Gujarat. India</p>
              <p><strong>Phone:</strong> <a href="tel:+91 93134 27474">+91 93134 27474</a></p>
              <p><strong>Email:</strong> <a href="mailto:info@asterickx">info@asterickx.com</a></p>
            </div>
            {/* <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
            </div> */}
          </div>
        </div>
      </div>
      <div className="text-center">
        <p>© 2025 Asterickx. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;